export default __webpack_public_path__ + "static/media/monegraph-letter.35763e10.png";